import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

class Home extends Component {
  render () {
    return (<Redirect to='/adoption' />)
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/routes/Landing/Home/index.js